import { runCardStream } from '../../generateLensCard';

/**
 * The one AskRichard turn every dataset-action prompt (F4's extend brief,
 * F6's "ask the model" SQL entry, F8's SQL edit) streams through: every sql
 * block kept, the prose answer, and a stream error if the transport itself
 * failed.
 *
 * A re-export of `generateLensCard.ts`'s own `runCardStream` rather than a
 * duplicate, per the brief's "reuse the call, do not fork it". Previously
 * re-exported the copy `LensCardDialog.tsx` carried (lane C1 exported it,
 * commit `41c9358ec`); repointed here (lane C4, LensCardDialog.tsx's
 * deletion) at `generateLensCard.ts`'s own export of the same function,
 * the one other lane B2 already consolidated the rest of the codebase onto
 * (commit `66681d46b`).
 */
export const streamDatasetSqlAnswer = runCardStream;
